import { useState, useEffect } from 'react';
import VBRadioGroup from '@virkesborsen/vb-js-commons/lib/components/new/vbRadioGroup';
import VBTextarea from '@virkesborsen/vb-js-commons/lib/components/new/vbTextarea';
import { uploadAdFile,createAdAttachment, deleteAdAttachmentsNew } from '../../api/services/ad';
import VBLoadingScreen from "@virkesborsen/vb-js-commons/lib/components/vbLoadingScreen";
import InfoIcon from './adcomponents/InfoIcon';
import { useAuctions } from '../../pages/auctions/context/AuctionsContext';


const Step3 = () => {
    const { adData, changeAdData, getAdFiles } = useAuctions();

    const [loadingMessage, setLoadingMessage] = useState(<h2 className="w-100 text-center pt-1">Vänta...</h2>);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({})

    const yesNoOptions = [
        { label: 'Ja', value: true },
        { label: 'Nej', value: false },
        { label: 'Vet ej', value: null },
    ];

    const certificationOptions = [
        { label: 'PEFC', value: 'PEFC' },
        { label: 'FSC', value: 'FSC' },
        { label: 'Dubbel', value: 'Both' },
        { label: 'Nej', value: 'No' },
        { label: 'Vet ej', value: 'donno' },
    ];

    useEffect(() => {
        window.scrollTo({ top: 100, behavior: 'smooth' })
    }, [])

    const uploadAdAttachments = async (files, id) => {
        const uploadPromises = files.map(async (file) => {
            try {
                const fileFormData = new FormData();
                fileFormData.append('file', file);
                fileFormData.append('original_file_name', file.name);

                const fileUploadResponse = await uploadAdFile(fileFormData)

                if (!fileUploadResponse.ok) {
                    console.error(`Error uploading file: ${file.name}`);
                    return null;
                }

                const fileData = fileUploadResponse.data;
                const attachmentResponse = await createAdAttachment(fileData, id)

                if (!attachmentResponse.ok) {
                    console.error(`Error creating attachment for file: ${file.name}`);
                    return null;
                }

                const attachmentData = attachmentResponse.data;

                return {
                    id: attachmentData.id,
                    name: fileData.original_file_name,
                    url: fileData.file
                };
            } catch (error) {
                console.error(`An unexpected error occurred for file: ${file.name}`, error);
                return null;
            }
        });

        const successfulAttachments = await Promise.all(uploadPromises);

        return successfulAttachments.filter(item => item !== null);
    }


    const handleFilesUpload = (event, index) => {
        let updatedData = { ...data };

        if (index == null) {
            const files = event.target.files;
            if (!updatedData.temp_files) updatedData.temp_files = [];
            Array.from(files).forEach(file => {
                updatedData.temp_files.push(file);
            });
        } else {
            if (updatedData.temp_files) {
                updatedData.temp_files.splice(index, 1);
                if (updatedData.temp_files.length === 0) delete updatedData.temp_files;
            }
        }

        setLoading(true);
        setData(updatedData);

        const filesToSend = Array.isArray(updatedData.temp_files)
            ? updatedData.temp_files
            : [updatedData.temp_files];

        uploadAdAttachments(filesToSend, adData.id)
            .then(() => getAdFiles())
            .finally(() => {
                setLoading(false);
                setData(prev => ({ ...prev, temp_files: [] }));
            });
            
    };

    return (
        <div>
            <VBLoadingScreen
                show_loading={loading}
                disable_reload_timeout={true}
                loading_text={loadingMessage}
            />

            {/* 1. Ground Preparation */}
            <Section
                title="1. Markbereding: Önskar du att ta in offert på markberedning i samband med din avverkning?"
                infoTitle="Vill du ha någon skogsvård i samband med din avverkning?"
                infoText="Önskar du få någon skogsvård utförd i samband med din avverkning/gallring och vill få offert på utförandet av skogsvården klickar du ”Ja” på dom åtgärder som du vill få utförda. Då får du prisförslag från eventuella köpare på dessa åtgärder utöver anbud på virket. Är du osäker? Klicka då på ”Vet ej”. Vill du inte ha någon åtgärd klickar du på ”Nej” istället."
                options={yesNoOptions}
                initial={adData.ground_preparation}
                onChange={(val) => changeAdData({ ground_preparation: val })}
            />

            {/* 2. Precleaning */}
            <Section
                title="2. Förröjning: Önskar du att ta in offert på röjning i samband med din avverkning?"
                infoTitle="Vill du ha någon skogsvård i samband med din avverkning?"
                infoText="Önskar du få någon skogsvård utförd i samband med din avverkning/gallring och vill få offert på utförandet av skogsvården klickar du ”Ja” på dom åtgärder som du vill få utförda. Då får du prisförslag från eventuella köpare på dessa åtgärder utöver anbud på virket. Är du osäker? Klicka då på ”Vet ej”. Vill du inte ha någon åtgärd klickar du på ”Nej” istället."
                options={yesNoOptions}
                initial={adData.precleaning_needed}
                onChange={(val) => changeAdData({ precleaning_needed: val })}
            />

            {/* 3. Replanting */}
            <Section
                title="3. Återplantering: Önskar du att ta in offert på återplantering i samband med din avverkning?"
                infoTitle="Vill du ha någon skogsvård i samband med din avverkning?"
                infoText="Önskar du få någon skogsvård utförd i samband med din avverkning/gallring och vill få offert på utförandet av skogsvården klickar du ”Ja” på dom åtgärder som du vill få utförda. Då får du prisförslag från eventuella köpare på dessa åtgärder utöver anbud på virket. Är du osäker? Klicka då på ”Vet ej”. Vill du inte ha någon åtgärd klickar du på ”Nej” istället."
                options={yesNoOptions}
                initial={adData.replanting}
                onChange={(val) => changeAdData({ replanting: val })}
            />

            {/* 4. GROT */}
            <Section
                title="4. Vill du sälja GROT?"
                infoTitle="Vill du sälja GROT?"
                infoText="Om du väljer ja här så får du även ett pris på biobränslet som faller ut när du avverkar. Vill du inte sälja biobränslet i samband med din avverkning väljer du nej."
                options={yesNoOptions}
                initial={adData.grot_included}
                onChange={(val) => changeAdData({ grot_included: val })}
            />

            {/* 5. Certification */}
            <Section
                title="5. Är skogen certifierad?"
                infoTitle="Är skogen certifierad?"
                infoText="Om din skog är certifierad välj då antingen PEFC, FSC alternativt dubbel om du har båda. Är du osäker? Välj då ”Vet ej”, är du inte certifierad väljer du ”Nej”."
                options={certificationOptions}
                 initial={adData.pefc_certified ? "PEFC" : adData.fsc_certified ? "FSC" : (adData.pefc_certified && adData.fsc_certified) ? "Both" : !(adData.pefc_certified && adData.fsc_certified) ? "No" : null}
                onChange={(selectedValue) => {
                    let certData = {};
                    if (selectedValue === 'PEFC') certData = { pefc_certified: true, fsc_certified: false };
                    else if (selectedValue === 'FSC') certData = { pefc_certified: false, fsc_certified: true };
                    else if (selectedValue === 'Both') certData = { pefc_certified: true, fsc_certified: true };
                    else if (selectedValue === 'No') certData = { pefc_certified: false, fsc_certified: false };
                    else certData = { pefc_certified: null, fsc_certified: null };
                    changeAdData(certData);
                }}
            />

            {/* 6. Comments */}
            <div className='row flex-md-row justify-content-between mt-5'>
                <div className='col-12 col-md-6'>
                    <div className='d-flex'>
                        <p className='neutral-charcoal fw-medium'>6. Övrig information:</p>
                        <InfoIcon title="Övrig information:" instructions={[
                            <p className='mb-0'>Här anger du all övrig information som är bra för köparen att känna till. Detta kan exempelvis vara vilka bilvägar man får köra på, kod till vägbom, om du önskar förskott, om skogen är snitslad/bandad eller annan viktig information som hjälper köparen. Om det inte finns någon övrig information så lämna denna ruta tom.</p>
                        ]} />
                    </div>
                    <VBTextarea
                        onChange={(val) => changeAdData({ comments: val })}
                        height="200px"
                        initial={adData.comments || ''}
                    /> 
                </div>
                <SideBox text="Här anger du all övrig information som är bra för köparen att känna till. Detta kan exempelvis vara vilka bilvägar man får köra på, kod till vägbom, om du önskar förskott, om skogen är snitslad/bandad eller annan viktig information som hjälper köparen. Om det inte finns någon övrig information så lämna denna ruta tom." />
            </div>

            {/* 7. Attachments */}
            <div className='row flex-md-row justify-content-between mt-5'>
                <div className='col-12 col-md-6'>
                    <div className='d-flex'>
                        <p className='neutral-charcoal fw-medium'>7. Bilagor:</p>
                        <InfoIcon title="Bilagor:" instructions={[
                            <p className='mb-0'><span className='fw-medium'>Ladda upp bilagor:</span> Här kan du ladda upp samtliga bilagor som rör den aktuella avverkningen/gallringen. Exempelvis skogsbruksplan, karta, villkor, stämplingslängder, avverkningsanmälan etc.</p>
                        ]} />
                    </div>

                    {adData.attachments?.length > 0 && (
                        <div className='bg-whiteoff rounded-top'>
                            {adData.attachments.map((file, idx) => (
                                <a key={idx} className='mt-2 bg-supp-forest-green-300 p-2 me-2 white rounded-pill n-fs-7 d-inline-block'>
                                    {file.name}
                                    <img
                                        src={`${Window.static_path}img/icons/X.svg`}
                                        className='ms-2 white-filter'
                                        role='button'
                                        width='16px'
                                        height='16px'
                                        onClick={async () => {
                                            setLoading(true);
                                            await deleteAdAttachmentsNew(file.id);
                                            getAdFiles();
                                            setLoading(false);
                                        }}
                                    />
                                </a>
                            ))}
                        </div>
                    )}

                    <div className='bg-whiteoff rounded-bottom'>
                        <label className="n-btn btn-forest-green btn-sm mt-3" role="button">
                            <img className="me-2" style={{ width: "18px", height: "18px" }} src={`${Window.static_path}img/icons/icon-left.svg`} />
                            Välj filer
                            <input
                                multiple
                                type='file'
                                id='attachments'
                                className='position-absolute'
                                style={{ opacity: 0, width: "1px", marginLeft: "24px" }}
                                onChange={handleFilesUpload}
                            />
                        </label>
                    </div>
                </div>
                <SideBox text="Här kan du ladda upp samtliga bilagor som rör den aktuella avverkningen/gallringen. Exempelvis skogsbruksplan, karta, villkor, stämplingslängder, avverkningsanmälan etc." />
            </div>
        </div>
    );
};

// --- Helper component for reuse ---
const Section = ({ title, infoTitle, infoText, options, initial, onChange }) => (
    <div className='row flex-md-row justify-content-between mt-5'>
        <div className='col-12 col-md-6'>
            <div className='d-flex'>
                <p className='w-lg-100 w-75 fw-medium neutral-charcoal'>{title}</p>
                <InfoIcon title={infoTitle} instructions={[<p className='mb-0'>{infoText}</p>]} />
            </div>
            <VBRadioGroup options={options} initial={initial} onChange={onChange} />
        </div>
        <SideBox text={infoText} />
    </div>
);

const SideBox = ({ text }) => (
    <div className='d-md-block d-none mt-3 mt-md-0 col-12 col-md-5'>
        <div className='rounded-3 bg-neutral-stone-300 p-3'>
            <p className='mb-0'><span className='fw-medium'>Skogsvård:</span> {text}</p>
        </div>
    </div>
);

export default Step3